/* ============================================================
   BT · Maak je set compleet
   Aan/uit zetten van de kaarten, variantkeuze per kaart en de
   mobiele slider. Toevoegen aan de winkelwagen gebeurt bewust NIET
   hier: bt-product-hero.js leest [data-bt-set-item].is-on uit zodra
   de klant op de knop in de koopmodule drukt.
   ============================================================ */
(function () {
  function init(root) {
    var track = root.querySelector('[data-bt-set-track]');
    if (!track || root.dataset.btSetReady === '1') return;
    root.dataset.btSetReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bt-set-item]'));

    /* ---------- aanvinken ---------- */
    cards.forEach(function (card) {
      function toggle(on) {
        if (on == null) on = !card.classList.contains('is-on');
        card.classList.toggle('is-on', on);
        card.setAttribute('aria-checked', on ? 'true' : 'false');
      }

      card.addEventListener('click', function (ev) {
        /* de variantkeuze en de link naar de productpagina mogen de kaart niet omzetten */
        if (ev.target.closest('[data-bt-set-variant]')) return;
        if (ev.target.closest('[data-bt-set-link]')) return;
        toggle();
      });

      card.addEventListener('keydown', function (ev) {
        if (ev.target !== card) return;
        if (ev.key === ' ' || ev.key === 'Enter' || ev.key === 'Spacebar') {
          ev.preventDefault();
          toggle();
        }
      });

      /* de link opent de productpagina; Enter/Space daarop mag niet ook de kaart omzetten */
      var link = card.querySelector('[data-bt-set-link]');
      if (link) {
        link.addEventListener('keydown', function (ev) { ev.stopPropagation(); });
      }

      /* ---------- variantkeuze ---------- */
      var sel = card.querySelector('[data-bt-set-variant]');
      if (!sel) return;
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        card.setAttribute('data-bt-variant', opt.value);

        /* de link volgt de gekozen variant */
        if (link && link.dataset.btSetUrl) {
          link.href = link.dataset.btSetUrl + '?variant=' + opt.value;
        }

        var now = card.querySelector('[data-bt-set-price]');
        if (now && opt.dataset.price) now.textContent = opt.dataset.price;

        var was = card.querySelector('[data-bt-set-compare]');
        if (was) {
          was.textContent = opt.dataset.compare || '';
          was.hidden = !opt.dataset.compare;
        }
      });
    });

    /* ---------- mobiele slider ---------- */
    var dots = root.querySelectorAll('[data-bt-set-dot]');
    if (dots.length) {
      var mark = function (i) {
        Array.prototype.forEach.call(dots, function (d, n) {
          d.classList.toggle('is-active', n === i);
        });
      };

      Array.prototype.forEach.call(dots, function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-bt-set-dot'), 10) || 0;
          if (cards[i]) track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });

      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = window.requestAnimationFrame(function () {
          tick = null;
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestGap = Infinity;
          cards.forEach(function (c, i) {
            var center = c.offsetLeft - track.offsetLeft + c.offsetWidth / 2;
            var gap = Math.abs(center - mid);
            if (gap < bestGap) { bestGap = gap; best = i; }
          });
          mark(best);
        });
      }, { passive: true });
    }

    /* Na een geslaagde toevoeging staan de producten in de winkelwagen;
       aangevinkt laten zou ze bij een tweede klik nog eens toevoegen. */
    document.addEventListener('bt:cart:added', function () {
      cards.forEach(function (card) {
        card.classList.remove('is-on');
        card.setAttribute('aria-checked', 'false');
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bt-set]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
